import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import React from 'react';

const Footer = () => {
    const { t } = useTranslation('common');
    return (
        <>
            <footer className="p-4 border-t-2 border-solid bg-neutral-100 relative transition-all duration-1000 text-[var(--primary)] mt-auto">
                <div className="container m-auto flex flex-col text-center items-center">
                    {/* rel="noopener" only, NOT noreferrer: this is our own link
                        to our own portfolio, and noreferrer strips the Referer
                        header so those ~360 clicks/year land as "direct" on
                        mortendlaursen.dk instead of being credited here. */}
                    <a
                        href="https://www.mortendlaursen.dk/"
                        target="_blank"
                        rel="noopener"
                        data-umami-event="redirect-to-mortendlaursen"
                    >
                        {t('common:made_with')}&nbsp;
                        <span className="underline">Morten</span>
                    </a>
                    <div className="flex flex-col">
                        <a
                            href="https://www.buymeacoffee.com/mortendl"
                            target="_blank"
                            rel="noreferrer"
                            className="text-center my-4"
                            data-umami-event="donation-clicked"
                        >
                            <Image
                                src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
                                alt="Buy Me A Coffee"
                                className="h-10 m-auto"
                                width={145}
                                height={40}
                                priority={false}
                            />
                        </a>
                        {/* <small>
                            <span className="font-bold underline">100%</span>
                            {' ' + t('common:rainforrest')}
                        </small> */}
                    </div>
                    {/* Trademark distance: CPH is a registered mark and this
                        site is not theirs. Global, so it shows on every page,
                        not only the ones that mention the airport by name. */}
                    <p className="mt-2 max-w-prose text-xs text-gray-500">
                        {t('common:not_affiliated')}
                    </p>
                </div>
            </footer>
        </>
    );
};

export default Footer;
